// @flow

const SSO_DATA_KEY = 'toggl-track-sso-data'
const SSO_EXPIRY_KEY = 'toggl-track-sso-data-expiry'
const STASHED_DATA_EXPIRY_MS = 60 * 60 * 1000

const removeSsoData = () => {
  try {
    localStorage.removeItem(SSO_DATA_KEY)
    localStorage.removeItem(SSO_EXPIRY_KEY)
  } catch (e) {
    throw new Error('localStorage is necessary for sso feature')
  }
}

const checkSsoDataExpiry = () => {
  try {
    const ssoExpiry = localStorage.getItem(SSO_EXPIRY_KEY)
    if (ssoExpiry) {
      try {
        const delta = parseInt(ssoExpiry, 10)
        if (delta < Date.now()) {
          removeSsoData()
        } else {
          return true
        }
      } catch {
        removeSsoData()
      }
    } else {
      removeSsoData()
    }
  } catch (err) {
    throw new Error('localStorage is necessary for sso feature')
  }

  return false
}

const getSsoData = () => {
  if (!checkSsoDataExpiry()) {
    return null
  }

  let dataString
  try {
    dataString = localStorage.getItem(SSO_DATA_KEY)
  } catch (e) {
    throw new Error('localStorage is necessary for sso feature')
  }

  if (!dataString) {
    return null
  }

  try {
    const data = JSON.parse(dataString)
    if (!data.ssoEmail) {
      removeSsoData()
      return null
    }

    return {
      client: (data.client: string),
      email: (data.email: string),
    }
  } catch {
    removeSsoData()
    return null
  }
}

export const setSsoData = (data: {
  client: 'webapp' | 'toggl-button',
  email: string,
}) => {
  if (typeof window === 'undefined') {
    return
  }
  try {
    localStorage.setItem(SSO_DATA_KEY, JSON.stringify(data))
    localStorage.setItem(
      SSO_EXPIRY_KEY,
      (Date.now() + STASHED_DATA_EXPIRY_MS).toString()
    )
  } catch (e) {
    throw new Error('localStorage is necessary for sso feature')
  }
}

export const getData = (queryString: string) => {
  if (typeof window === 'undefined') {
    return { email: '', client: '', token: '' }
  }
  const params = new URLSearchParams(queryString)
  const ssoData = getSsoData()
  const client = params.get('client') || ssoData?.client || ''
  const email = params.get('email') || ssoData?.email || ''
  const token =
    params.get('confirmation_code') || params.get('confirmation code') || ''

  return { client, email, token }
}
